export function numberFormatter(input: string): number {
  return Number.parseInt(input.replace(/\D/g, ""));
}
